import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DownloadService } from '~/api/services/downloadFiles'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery'
import { handleErrors } from '~/utils/helpers'

const MilkMoney:React.FC = () => {
  const { t } = useTranslation()
  const tableColumnHeaders = [
    {
      name: t('Billing month'),
      key: 'billingMonth',
      type: 'date',
      format: 'MMM YYYY'
    },
    {
      name: t('Delivery (in l)'),
      key: 'amountInLiters',
      type: 'no-unit-number',
      decimalScale: 0

    },
    {
      name: t('Total amount (in kg)'),
      key: 'amountInKg',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('Milk price net (€ Ct/kg)'),
      key: 'farmerNetPrice',
      type: 'no-unit-number'
    },
    {
      name: t('Milk price net (in €)'),
      key: 'netTotal',
      type: 'no-unit-number'
    },
    {
      name: t('Milk price brutto (in €)'),
      key: 'grossTotal',
      type: 'no-unit-number'
    },
    {
      name: t('Payout amount (in €)'),
      key: 'total',
      type: 'no-unit-number'
    },
    {
      name: t('Actions')
    }
  ]
  const actions = [
    {
      popupMessage: t('Download milk bill'),
      type: 'icon',
      name: 'cloud download',
      size: 'large',
      actionType: 'download'
    }
  ]
  
  const [loadingAction, setLoadingAction] = useState({
    type: '',
    id: null,
    value: false,
    idKey: ''
  })
  const [dataFiltered, setDataFiltered] = useState({
    rows: 20,
    page: 0
  })

  const {
    data: invoices,
    isLoading: isLoading,
    isFetching: isFetchingData,
    refetch: fetchData
  } = MilkMoneyQuery.getFarmInvoices({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    fetchData()
  }, [dataFiltered])

  async function handleDownloadPdf(row, type) {
    setLoadingAction({
      type: type,
      id: row.id,
      value: true,
      idKey: 'id'
    })
    try {
      await DownloadService.downloadFileWithName(`milk-money/milk-invoices/${row.id}/preview/pdf`)
    } catch (error) {
      handleErrors(error)
    }
    setLoadingAction({
      type: '',
      id: null,
      value: false,
      idKey: ''
    })
  }

  function handleActionClick(row, type) {
    switch (type) {
      case 'download':
        return handleDownloadPdf(row, type)
      default:
        return
    }
  }

  function renderTable() {
    return <TableComponent
      rows={rows}
      total={filtered}
      actions={actions}
      loadingAction={loadingAction}
      tableColumnHeaders={tableColumnHeaders}
      handleClickAction={(row, type) => handleActionClick(row, type)}
      isFetchingData={isFetchingData}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      animated
    />
  }

  const { filtered, rows } = invoices ? invoices : { filtered: 0, rows: [] };

  return <Layout
    title={t('Milk money')}
    segmented
    isBusy={isLoading}
  >
    {renderTable()}
  </Layout>
}
export default MilkMoney